import React, { useRef, useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import axios from "axios";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import BASEURL from "../../Utils/Baseurl";
import { getOfferLetterByIdQuery, updateOfferLetterQuery } from "./Queries";
import assets from "../../../config/assestsConfig";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import sign from "../../../assest/LogoAndFavicon/Hrsign/RishiSign.png";

// ============================================================================
// PDF LAYOUT IMPORTS CONFIGURATION
// Mapped according to assetsConfig & App.js
// ============================================================================

// --- Keelis import (Mapped to src/App.js:L28-L30) ---
import KeelisReusablePDFLayout from "../../pdf/ReusablePDFLayout";

// --- EG import (Mapped to src/App.js:L33-L35) ---
import EgReusablePDFLayout from "../../egpdf/ReusablePDFLayout";
import { Button } from "@mui/material";
import { ArrowBack, Download } from "@mui/icons-material";

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

const formatNumberWithCommas = (num) => {
  if (num === null || num === undefined || isNaN(Number(num))) return "0";
  return Number(num).toLocaleString("en-IN");
};

const numberToIndianWords = (num) => {
  if (!num || isNaN(Number(num))) return "";

  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const intNum = Math.floor(Number(num));
  if (intNum < 20) return units[intNum];
  if (intNum < 100)
    return (
      tens[Math.floor(intNum / 10)] +
      (intNum % 10 !== 0 ? " " + units[intNum % 10] : "")
    );

  let words = "";

  const getWords = (n, suffix) => {
    if (n > 0) words += numberToIndianWords(n) + " " + suffix + " ";
  };

  const crore = Math.floor(intNum / 10000000);
  const lakh = Math.floor((intNum % 10000000) / 100000);
  const thousand = Math.floor((intNum % 100000) / 1000);
  const hundred = Math.floor((intNum % 1000) / 100);
  const remainder = intNum % 100;

  getWords(crore, "Crore");
  getWords(lakh, "Lakh");
  getWords(thousand, "Thousand");
  getWords(hundred, "Hundred");

  if (remainder > 0) words += "and " + numberToIndianWords(remainder);

  return words.trim();
};

function formatNameInitials(name) {
  if (!name) return "";
  const parts = name.trim().toLowerCase().split(" ");
  return parts
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

const headerStyle = {
  backgroundColor: "#d9d9d9",
  fontWeight: "bold",
};

const totalRowStyle = {
  backgroundColor: "#d9d9d9",
};

// ============================================================================
// EG OFFER LETTER TEMPLATE (Mapped to src/pages/egpdf/offer/Offer.jsx)
// ============================================================================
const EgOfferTemplate = ({
  Salarydata,
  candidatedetails,
  EarningData,
  Deductiondata,
  Benefitsdata,
  formattedDate,
  Dateformat,
  NextDateformat,
  formattedCTC,
  ctcInWords,
}) => {
  return (
    <>
      <EgReusablePDFLayout>
        <div className="parentcls">
          <div style={{ display: "flex", width: "100%" }}>
            <p className="boloff" style={{ width: "80%" }}>
              <span
                style={{
                  borderBottom: "2px solid black",
                  marginLeft: "89px",
                }}
              >
                OFFER LETTER
              </span>{" "}
            </p>
            <p className="boloff" style={{ width: "25%" }}>
              <b>{Dateformat}</b>{" "}
            </p>
          </div>
          <p style={{ margin: "30px 0" }} className="paraoff">
            Dear <b>{formatNameInitials(candidatedetails?.candidateName)}</b>,
          </p>
          <p style={{ margin: "15px 0" }} className="paraoff">
            Congratulations!{" "}
          </p>
          <p style={{ margin: "10px 0 30px 0" }} className="paraoff">
            We are pleased to confirm that you have been selected to work with{" "}
            <b>EverGuard Insurance Broking Services Private Limited.</b> We are
            delighted to share with you the following job offer.{" "}
          </p>
          <p className="paraoff">
            You have been selected for the position of{" "}
            <span className="boldsoff">{candidatedetails?.position}</span> with
            an annual cost to the company of{" "}
            <span className="boldsoff">
              {" "}
              Rs.{formattedCTC} ({`${ctcInWords} Only`})
            </span>{" "}
            . This includes all monthly payments, incentives and annual payments
            fully described in Annexure A herewith. The salary offered also
            includes communication/internet charges incurred during your work
            with the organization and there would be no separate reimbursement
            for the same. However, your appointment will be valid subject to
            receipt of requisite documents and satisfactory references provided
            by you.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            Your work with us will start on{" "}
            <span className="boldsoff">{formattedDate}</span> at{" "}
            <span className="boldsoff">11 am </span> at our{" "}
            <span className="boldsoff">Office</span> . Your working hours will
            be from Monday to Saturday from 09:30 am to 06:30 pm. Your probation
            period will be for{" "}
            <span className="boldsoff">six months</span> . The completion of
            additional employment forms is part of this offer of employment and
            will be completed in person upon your arrival.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            Please note that your presence in the office is required as per
            business requirements and work from home is neither a mandate nor
            optional unless specified by HR. This offer letter is valid based on
            the submission and verification of all necessary documents, and
            liable to be revoked if any document/detail shared is untrue or does
            not match the verbal information or declaration shared during the
            process of the interview.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            You are required to report at our{" "}
            <span className="boldsoff">
              No 672, 3rd Floor, Temple Tower, Anna Salai, Nandanam, Chennai,
              Tamil Nadu 600 035
            </span>{" "}
            for documentation and orientation on the day of your
          </p>
        </div>
      </EgReusablePDFLayout>

      <EgReusablePDFLayout>
        <div className="parentcls">
          <p className="paraoff">
            joining. Further, this offer of employment shall be deemed complete
            on your submission of credentials and documents mentioned under
            Annexure B herewith.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            Kindly sign and revert this document on or before{" "}
            <span style={{ fontWeight: "bold" }}>{NextDateformat}</span>.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            We are confident that you will be able to make a significant
            contribution to the success of our Company and look forward to
            working with you.
          </p>
          <p className="boldsoff" style={{ marginTop: "25px" }}>
            For EverGuard Insurance Broking Services Private Limited
          </p>
          <div style={{ marginTop: "15px" }}>
            <img src={sign} width={"180px"} alt="signature" />
          </div>
          <p className="boldsoff">
            HR Manager
          </p>

          <div
            style={{
              border: "1px dashed black",
              margin: "29px 0px ",
              marginRight: "15px",
            }}
          ></div>
          <p className="paraoff">
            I, <b>{formatNameInitials(candidatedetails?.candidateName)}</b>, do
            hereby accept the offer as described in this letter and the
            related Annexures herewith.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              gap: "150px",
            }}
          >
            <p
              className="paraoff"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Signature
            </p>
            <p
              className="paraoff"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Date
            </p>
          </div>
        </div>
      </EgReusablePDFLayout>

      <EgReusablePDFLayout>
        <div className="parentcls">
          <p className="bol">Annexure A</p>
          <div
            style={{
              display: "flex",
              margin: "10px 40px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "70%" }}>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Name:</span>{" "}
                {formatNameInitials(candidatedetails?.candidateName)}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Designation:</span>{" "}
                {candidatedetails?.position || ""}
              </p>
            </div>

            <div style={{ width: "50%", marginLeft: "155px" }}>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Location:</span> Chennai
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Department:</span>{" "}
                {candidatedetails?.department || ""}
              </p>
            </div>
          </div>
          <table
            className="tableStyle"
            border="1"
            cellSpacing="0"
            cellPadding="5"
            style={{ margin: "30px 30px" }}
          >
            <thead>
              <tr style={headerStyle}>
                <td>CTC ALLOCATION</td>
                <td>
                  {Salarydata?.ctc
                    ? (Number(Salarydata?.ctc) / 12)?.toFixed(2)
                    : 0}
                </td>
                <td>{Salarydata?.ctc || 0}</td>
              </tr>
              <tr style={headerStyle}>
                <td>Salary Components</td>
                <td>Monthly</td>
                <td>Annually</td>
              </tr>
            </thead>
            <tbody>
              {EarningData.length > 0 && (
                <>
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      <b>Earnings</b>
                    </td>
                  </tr>

                  {EarningData.map((item, index) => (
                    <tr key={`earning-${index}`}>
                      <td>{item.componentName || ""}</td>
                      <td>{item.monthly || 0}</td>
                      <td>{item.yearly || 0}</td>
                    </tr>
                  ))}

                  <tr style={totalRowStyle}>
                    <td>
                      <b>Total Earnings</b>
                    </td>
                    <td>
                      <b>
                        {EarningData.reduce(
                          (sum, item) => sum + (Number(item.monthly) || 0),
                          0
                        )}
                      </b>
                    </td>
                    <td>
                      <b>
                        {EarningData.reduce(
                          (sum, item) => sum + (Number(item.yearly) || 0),
                          0
                        )}
                      </b>
                    </td>
                  </tr>
                </>
              )}

              {Deductiondata.length > 0 && (
                <>
                  <tr>
                    <td colSpan="3">
                      <b>Deductions</b>
                    </td>
                  </tr>

                  {Deductiondata.map((item, index) => (
                    <tr key={`deduction-${index}`}>
                      <td>{item.componentName || ""}</td>
                      <td>{item.monthly || 0}</td>
                      <td>{item.yearly || 0}</td>
                    </tr>
                  ))}

                  <tr style={totalRowStyle}>
                    <td>
                      <b>Total Deductions</b>
                    </td>
                    <td>
                      <b>
                        {Deductiondata.reduce(
                          (sum, item) => sum + (Number(item.monthly) || 0),
                          0
                        )}
                      </b>
                    </td>
                    <td>
                      <b>
                        {Deductiondata.reduce(
                          (sum, item) => sum + (Number(item.yearly) || 0),
                          0
                        )}
                      </b>
                    </td>
                  </tr>
                </>
              )}

              {Benefitsdata.length > 0 && (
                <>
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      <b>Benefits</b>
                    </td>
                  </tr>

                  {Benefitsdata.map((item, index) => (
                    <tr key={`benefit-${index}`}>
                      <td>{item.componentName || ""}</td>
                      <td>{item.monthly || 0}</td>
                      <td>{item.yearly || 0}</td>
                    </tr>
                  ))}

                  <tr style={totalRowStyle}>
                    <td>
                      <b>Total Benefits</b>
                    </td>
                    <td>
                      <b>
                        {Benefitsdata.reduce(
                          (sum, item) => sum + (Number(item.monthly) || 0),
                          0
                        )}
                      </b>
                    </td>
                    <td>
                      <b>
                        {Benefitsdata.reduce(
                          (sum, item) => sum + (Number(item.yearly) || 0),
                          0
                        )}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Benefits Total (E)</b>
                    </td>
                    <td>
                      <b>{Salarydata?.totalBenefits || 0}</b>
                    </td>
                    <td>
                      <b>
                        {Salarydata?.totalBenefits
                          ? (Number(Salarydata?.totalBenefits) * 12)?.toFixed(2)
                          : 0}
                      </b>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td>
                  <b>Monthly & Annual CTC </b>
                </td>
                <td>
                  <b>
                    {Salarydata?.ctc
                      ? (Number(Salarydata?.ctc) / 12)?.toFixed(2)
                      : 0}
                  </b>
                </td>
                <td>
                  <b>{Salarydata?.ctc || 0}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Net Take Home </b>
                </td>
                <td>
                  <b>{Salarydata?.netPay || 0}</b>
                </td>
                <td>
                  <b>
                    {Salarydata?.netPay
                      ? (Number(Salarydata?.netPay) * 12)?.toFixed(2)
                      : 0}
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              display: "flex",
              width: "80%",
              justifyContent: "space-between",
              marginTop: "-14px",
            }}
          >
            <div style={{ marginLeft: "25px" }}>
              <img src={sign} width={"180px"} alt="signature" />
              <p className="boldsoff">HR Manager</p>
            </div>
            <div
              style={{
                width: "50%",                
                marginLeft: "34%",
              }}
            >
              <p className="paraoff" style={{ marginBottom: "0px" }}>
                I accept the above offer
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Name:</span>{" "}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Signature:</span>{" "}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Date:</span>{" "}
              </p>
            </div>
          </div>
        </div>
      </EgReusablePDFLayout>

      <EgReusablePDFLayout>
        <div className="parentcls">
          <p className="boldsoff" style={{ textAlign: "center" }}>
            Annexure B
          </p>
          <p className="boldsoff" style={{ margin: "40px 0", textAlign: "center" }}>
            Documents for Employment
          </p>
          <p className="boldsoff" style={{ margin: "40px 0", textAlign: "center" }}>
            Kindly submit the photocopy of the below mentioned documents:
          </p>
          <div style={{ margin: "10px 95px", textAlign: "center" }}>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              1. <span>Relieving letter from your past employers.</span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              2.{" "}
              <span>
                Your educational certificates (starting from 10th std){" "}
              </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              3.{" "}
              <span>
                Proof of Salary Drawn – Copy of your appointment / revision
                letter <br />
                <span style={{ marginLeft: "16px" }}>
                  along with annual compensation package from your past
                  employer.
                </span>{" "}
              </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              4. <span>Two numbers of passport size photograph. </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              5. <span>PAN Card </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              6. <span>Bank Passbook Front Page Xerox </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              7. <span>Aadhar card </span>
            </p>
          </div>
          <p className="bolds" style={{ margin: "40px 90px", fontStyle: "italic" }}>
            *Please Note:{" "}
          </p>
          <p
            className="bolds"
            style={{ margin: "40px 30px 40px 90px", fontStyle: "italic" }}
          >
            We request you to bring both original and photocopies of your
            testimonials. Photocopies of the document will be verified and
            retained for our records. Originals will be returned to you{" "}
          </p>
        </div>
      </EgReusablePDFLayout>
    </>
  );
};

// ============================================================================
// KEELIS OFFER LETTER TEMPLATE (Mapped to src/pages/pdf/offer/Offer.jsx)
// ============================================================================
const KeelisOfferTemplate = ({
  Salarydata,
  candidatedetails,
  EarningData,
  Deductiondata,
  Benefitsdata,
  formattedDate,
  Dateformat,
  NextDateformat,
  formattedCTC,
  ctcInWords,
}) => {  
  return (
    <>
      <KeelisReusablePDFLayout>
        <div className="parentcls">
          <div style={{ display: "flex", width: "100%" }}>
            <p className="boloff" style={{ width: "80%" }}>
              <span
                style={{
                  borderBottom: "2px solid black",
                  marginLeft: "89px",
                }}
              >
                OFFER LETTER
              </span>{" "}
            </p>
            <p className="boloff" style={{ width: "25%" }}>
              <span
                //contentEditable
                suppressContentEditableWarning={true}
                style={{
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                <b>{Dateformat}</b>{" "}
              </span>
            </p>
          </div>
          <p style={{ margin: "30px 0" }} className="paraoff">
            Dear <b>{formatNameInitials(candidatedetails?.candidateName)}</b>,
          </p>
          <p style={{ margin: "15px 0" }} className="paraoff">
            Congratulations!{" "}
          </p>
          <p style={{ margin: "10px 0 30px 0" }} className="paraoff">
            We are pleased to confirm that you have been selected to work with{" "}
            <b>Keel Info Solution Private Limited.</b> We are delighted to share
            with you the following job offer.{" "}
          </p>
          <p className="paraoff">
            You have been selected for the position of{" "}
            <span className="boldsoff">{candidatedetails?.position}</span> with
            an annual cost to the company of{" "}
            <span className="boldsoff">
              {" "}
              Rs.{formattedCTC} ({`${ctcInWords} Only`})
            </span>{" "}
            . This includes all monthly payments, incentives and annual payments
            fully described in Annexure A herewith. The salary offered also
            includes communication/internet charges incurred during your work
            with the organization and there would be no separate reimbursement
            for the same. However, your appointment will be valid subject to
            receipt of requisite documents and satisfactory references provided
            by you.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            Your work with us will start on{" "}
            <span
              className="boldsoff"
              //contentEditable
              suppressContentEditableWarning={true}
              style={{
                outline: "none",
                padding: "2px",
                cursor: "text",
              }}
            >
              {formattedDate}
            </span>{" "}
            at <span className="boldsoff">11 am </span> at our{" "}
            <span className="boldsoff">Office</span> . Your working hours will
            be from Monday to Friday from 09:30 am to 05:30 pm.{" "}
            <span
              //contentEditable
              suppressContentEditableWarning={true}
              style={{
                outline: "none",
                padding: "2px",
                cursor: "text",
              }}
            >
              {" "}
              Your probation period will be for{" "}
              <span className="boldsoff">six months.</span>
            </span>{" "}
            The completion of additional employment forms is part of this offer
            of employment and will be completed in person upon your arrival.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            Please note that your presence in the office is required as per
            business requirements and work from home is neither a mandate nor
            optional unless specified by HR. This offer letter is valid based on
            the submission and verification of all necessary documents, and
            liable to be revoked if any document/detail shared is untrue or does
            not match the verbal information or declaration shared during the
            process of the interview.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            You are required to report at our{" "}
            <span className="boldsoff">
              No. 672, 3rd Floor, Temple Tower, Anna Salai, CIT Nagar West,
              Nandanam, Chennai – 600035
            </span>{" "}
            for documentation and orientation on the day of your
          </p>
        </div>
      </KeelisReusablePDFLayout>

      <KeelisReusablePDFLayout>
        <div className="parentcls">
          <p className="paraoff">
            joining. Further, this offer of employment shall be deemed complete
            on your submission of credentials and documents mentioned under
            Annexure B herewith.
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            Kindly sign and revert this document on or before{" "}
            <span
              //contentEditable
              suppressContentEditableWarning={true}
              style={{
                outline: "none",
                padding: "2px",
                cursor: "text",
                fontWeight: "bold",
              }}
            >
              {NextDateformat}.
            </span>
          </p>
          <p className="paraoff" style={{ margin: "30px 0" }}>
            We are confident that you will be able to make a significant
            contribution to the success of our Company and look forward to
            working with you.
          </p>
          <p className="boldsoff" style={{ marginTop: "25px" }}>
            For Keel Info Solution Private Limited
          </p>
          <div
            style={{
              marginTop: "15px",
              width: "150px",
              height: "50px",
              borderBottom: "1px solid #000",
              backgroundColor: "transparent",
            }}
          >
            {/* No need of Sign for Keelis */}
            {/* <img src={sign} width={"180px"} alt="signature" /> */}
          </div>
          <p className="boldsoff" style={{ marginTop: "5px" }}>
            HR Manager
          </p>

          <div
            style={{
              border: "1px dashed black",
              margin: "29px 0px ",
              marginRight: "15px",
            }}
          ></div>
          <p className="paraoff">
            I, <b>{formatNameInitials(candidatedetails?.candidateName)}</b>, do
            hereby accept the offer as described in this letter and the
            related Annexures herewith.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              gap: "150px",
            }}
          >
            <p
              className="paraoff"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Signature
            </p>
            <p
              className="paraoff"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Date
            </p>
          </div>
        </div>
      </KeelisReusablePDFLayout>

      <KeelisReusablePDFLayout>
        <div className="parentcls">
          <p className="bol">Annexure A</p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              margin: "10px 40px",
              width: "88%",
            }}
          >
            <div>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Name:</span>{" "}
                {formatNameInitials(candidatedetails?.candidateName)}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Designation:</span>{" "}
                {candidatedetails?.position}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Grade:</span> A
              </p>
            </div>

            <div style={{ textAlign: "right" }}>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Location:</span> Chennai
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Department:</span>{" "}
                {candidatedetails?.department}
              </p>
            </div>
          </div>
          <table
            className="tableStyle"
            border="1"
            cellSpacing="0"
            cellPadding="5"
            style={{ margin: "15px 30px" }}
            //contentEditable
            suppressContentEditableWarning={true}
          >
            <thead>
              <tr style={headerStyle}>
                <td colSpan="3" style={{ textAlign: "left" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <span>CTC ALLOCATION</span>
                    <span>
                      {Salarydata?.ctc
                        ? (Number(Salarydata?.ctc) / 12)?.toFixed(2)
                        : "0.00"}
                    </span>
                    <span>{Salarydata?.ctc || "0"}</span>
                  </div>
                </td>
              </tr>

              <tr style={headerStyle}>
                <td>Salary Components</td>
                <td>Monthly</td>
                <td>Annually</td>
              </tr>
            </thead>
            <tbody>
              {EarningData.length > 0 && (
                <>
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center" }}
                      className="para"
                    >
                      <b>Fixed (A)</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{EarningData[0]?.componentName || ""}</td>
                    <td>{EarningData[0]?.monthly || ""}</td>
                    <td>{EarningData[0]?.yearly || ""}</td>
                  </tr>
                  <tr>
                    <td>{EarningData[1]?.componentName || ""}</td>
                    <td>{EarningData[1]?.monthly || ""}</td>
                    <td>{EarningData[1]?.yearly || ""}</td>
                  </tr>
                  <tr style={totalRowStyle}>
                    <td>
                      <b>Total (A)</b>
                    </td>
                    <td>
                      <b>
                        {EarningData[0]?.monthly && EarningData[1]?.monthly
                          ? Number(EarningData[0]?.monthly) +
                            Number(EarningData[1]?.monthly)
                          : "0"}{" "}
                      </b>
                    </td>
                    <td>
                      <b>
                        {EarningData[0]?.yearly && EarningData[1]?.yearly
                          ? Number(EarningData[0]?.yearly) +
                            Number(EarningData[1]?.yearly)
                          : "0"}
                      </b>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      <b>Reimbursement Basket (B)</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{EarningData[2]?.componentName || ""}</td>
                    <td>{EarningData[2]?.monthly || "0"}</td>
                    <td>{EarningData[2]?.yearly || "0"}</td>
                  </tr>
                  <tr style={totalRowStyle}>
                    <td>
                      <b>Total (B)</b>
                    </td>
                    <td>{EarningData[2]?.monthly || "0"}</td>
                    <td>{EarningData[2]?.yearly || "0"}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{EarningData[3]?.componentName || ""} (C)</b>
                    </td>
                    <td>{EarningData[3]?.monthly || "0"}</td>
                    <td>{EarningData[3]?.yearly || "0"}</td>
                  </tr>
                  <tr style={totalRowStyle}>
                    <td>
                      <b>Gross (D) = (A+B+C)</b>
                    </td>
                    <td>
                      <b>
                        {Salarydata?.gross
                          ? Number(Salarydata?.gross)?.toFixed(2)
                          : "0.00"}
                      </b>{" "}
                    </td>
                    <td>
                      <b>
                        {Salarydata?.gross
                          ? (Number(Salarydata?.gross) * 12)?.toFixed(2)
                          : "0"}
                      </b>{" "}
                    </td>
                  </tr>
                </>
              )}
              {Deductiondata.length > 0 && (
                <>
                  <tr>
                    <td colSpan="3">
                      <b>Deductions</b>
                    </td>
                  </tr>
                  {Deductiondata.length > 1 && (
                  <tr>
                    <td>{Deductiondata[1]?.componentName || ""}</td>
                    <td>{Deductiondata[1]?.monthly || "0"}</td>
                    <td>{Deductiondata[1]?.yearly || "0"}</td>
                  </tr>
                  )}                  
                  <tr>
                    <td>{Deductiondata[0]?.componentName || ""}</td>
                    <td>{Deductiondata[0]?.monthly || "0"}</td>
                    <td>{Deductiondata[0]?.yearly || "0"}</td>
                  </tr>
                  <tr style={totalRowStyle}>
                    <td>
                      <b>Total Deductions</b>
                    </td>
                    <td>
                      <b>
                        {Salarydata?.totalDeductions
                          ? Number(Salarydata?.totalDeductions)?.toFixed(2)
                          : "0.00"}
                      </b>
                    </td>
                    <td>
                      <b>
                        {Deductiondata?.[1]?.yearly != null ||
                        Deductiondata?.[0]?.yearly != null
                          ? (
                              (Number(Deductiondata?.[1]?.yearly) || 0) +
                              (Number(Deductiondata?.[0]?.yearly) || 0)
                            ).toFixed(2)
                          : "0"}
                      </b>
                    </td>
                  </tr>
                </>
              )}
              {Benefitsdata.length > 0 && (
                <>
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      <b>Benefits</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{Benefitsdata[1]?.componentName || ""}</td>
                    <td>{Benefitsdata[1]?.monthly || "0"}</td>
                    <td>{Benefitsdata[1]?.yearly || "0"}</td>
                  </tr>
                  <tr>
                    <td>{Benefitsdata[0]?.componentName || ""}</td>
                    <td>{Benefitsdata[0]?.monthly || "0"}</td>
                    <td>{Benefitsdata[0]?.yearly || "0"}</td>
                  </tr>
                  <tr>
                    <td>{Benefitsdata[2]?.componentName || ""}</td>
                    <td>{Benefitsdata[2]?.monthly || "0"}</td>
                    <td>{Benefitsdata[2]?.yearly || "0"}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Benefits Total (E)</b>
                    </td>
                    <td>
                      <b>{Salarydata?.totalBenefits || 0}</b>
                    </td>
                    <td>
                      <b>
                        {Salarydata?.totalBenefits
                          ? (Number(Salarydata?.totalBenefits) * 12)?.toFixed(2)
                          : "0.00"}
                      </b>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td>
                  <b>Monthly & Annual CTC </b>
                </td>
                <td>
                  <b>
                    {((Number(Salarydata?.ctc) || 0) / 12)?.toFixed(2)}
                  </b>
                </td>
                <td>
                  <b>{Salarydata?.ctc || 0}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Net Take Home </b>
                </td>
                <td>
                  <b>{Salarydata?.netPay || 0}</b>
                </td>
                <td>
                  <b>
                    {((Number(Salarydata?.netPay) || 0) * 12)?.toFixed(2)}
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              display: "flex",
              width: "80%",
              justifyContent: "space-between",
              marginTop: "15px",
            }}
          >
            <div style={{ marginLeft: "25px" }}>
              <div
                style={{
                  width: "150px",
                  height: "50px",
                  borderBottom: "1px solid #000",
                  backgroundColor: "transparent",
                }}
              >

                {/* No Need Sign for Keelis */}
                {/* <img src={sign} width="150px" alt="signature" /> */}
              </div>

              <p className="boldsoff" style={{ marginTop: "5px" }}>
                HR Manager
              </p>
            </div>
            <div
              style={{
                width: "50%",
                marginTop: "-12px",
                marginLeft: "38%",
              }}
            >
              <p className="paraoff" style={{ marginBottom: "0px" }}>
                I accept the above offer
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Name:</span>{" "}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Signature:</span>{" "}
              </p>
              <p className="para">
                <span style={{ fontWeight: "800" }}>Date:</span>{" "}
              </p>
            </div>
          </div>
        </div>
      </KeelisReusablePDFLayout>

      <KeelisReusablePDFLayout>
        <div className="parentcls">
          <p className="boldsoff" style={{ textAlign: "center" }}>
            Annexure B
          </p>
          <p className="boldsoff" style={{ margin: "40px 0", textAlign: "center" }}>
            Documents for Employment
          </p>
          <p className="boldsoff" style={{ margin: "40px 0", textAlign: "center" }}>
            Kindly submit the photocopy of the below mentioned documents:
          </p>
          <div style={{ margin: "10px 95px", textAlign: "center" }}>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              1. <span>Relieving letter from your past employers.</span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              2.{" "}
              <span>
                Your educational certificates (starting from 10th std){" "}
              </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              3.{" "}
              <span>
                Proof of Salary Drawn – Copy of your appointment / revision
                letter <br />
                <span style={{ marginLeft: "16px" }}>
                  along with annual compensation package from your past
                  employer.
                </span>{" "}
              </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              4. <span>Two numbers of passport size photograph. </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              5. <span>PAN Card </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              6. <span>Bank Passbook Front Page Xerox </span>
            </p>
            <p className="paraoff" style={{ margin: "15px 0" }}>
              7. <span>Aadhar card </span>
            </p>
          </div>
          <p className="bolds" style={{ margin: "40px 90px", fontStyle: "italic" }}>
            *Please Note:{" "}
          </p>
          <p
            className="bolds"
            style={{ margin: "40px 30px 40px 90px", fontStyle: "italic" }}
          >
            We request you to bring both original and photocopies of your
            testimonials. Photocopies of the document will be verified and
            retained for our records. Originals will be returned to you{" "}
          </p>
        </div>
      </KeelisReusablePDFLayout>
    </>
  );
};

// ============================================================================
// MAIN OFFER PDF COMPONENT
// ============================================================================
const OfferPDF = ({ id: propId }) => {
  const navigate = useNavigate();
  const pdfRef = useRef();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // Get offer ID from props, URL query parameter (?id=...), or React Router location state
  const offerId =
    propId ||
    searchParams.get("id") ||
    location?.state?.id ||
    location?.state;

  const [Salarydata, setSalarydata] = useState(null);
  const [Earning, setEarning] = useState([]);
  const [Deductions, setDeductions] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  const [candidatedetails, setcandidatedetails] = useState({
    candidateName: "",
    position: "",
    location: "Chennai",
    department: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (offerId) {
      getEmployeeOfferLetterById(offerId);
    }
  }, [offerId]);

  // Uses getEmployeeOfferLetterById query (identical to OfferLetterForm.js)
  const getEmployeeOfferLetterById = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: getOfferLetterByIdQuery,
          variables: {
            id: id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data?.data?.employeeOfferLetterById;

      if (result?.success) {
        const data = result?.data;

        // Ensure breakdown is correctly parsed into an array
        let breakdown = data?.breakdown;
        try {
          while (typeof breakdown === "string") {
            breakdown = JSON.parse(breakdown);
          }
        } catch (error) {
          console.error("Error parsing breakdown", error);
        }
        if (!Array.isArray(breakdown)) {
          breakdown = breakdown?.type_two || [];
        }

        setSalarydata(data);

        setcandidatedetails({
          candidateName: data?.fullName || "",
          position: data?.designation || "",
          location: "Chennai",
          department: data?.department || "",
        });

        let earnings = Array.isArray(breakdown)
          ? breakdown.filter((val) => val.type === "Earnings")
          : [];
        let deduction = Array.isArray(breakdown)
          ? breakdown.filter((val) => val.type === "Deductions") || []
          : [];
        let benefits = Array.isArray(breakdown)
          ? breakdown.filter((val) => val.type === "Benefits") || []
          : [];
        const gratuity = benefits.find(
          (item) => item.componentName === "GRATUITY"
        );
        const finalData = gratuity ? [...deduction, gratuity] : deduction;

        setEarning(earnings);
        setDeductions(finalData);
        setBenefits(benefits);

        return data;
      } else {
        console.error("Failed to fetch offer letter:", result?.message);
        Swal.fire({
          position: "center",
          icon: "error",
          title: result?.message || "Failed to fetch offer letter",
          showConfirmButton: false,
          timer: 2500,
        });
        return null;
      }
    } catch (error) {
      console.error("Error fetching employee offer letter:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title:
          error?.response?.data?.errors?.[0]?.message ||
          error?.message ||
          "Failed to fetch offer letter",
        showConfirmButton: false,
        timer: 2500,
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  let EarningData =
    Array.isArray(Earning) && Earning.length > 0
      ? Earning
          .filter((val) => typeof val?.componentName === "string")
          .sort((a, b) =>
            (a?.componentName || "").localeCompare(b?.componentName || "")
          )
      : [];

  let Deductiondata = Deductions
    .filter(
      (val) =>
        typeof val?.componentName === "string" &&
        /^[A-Za-z]/.test(val.componentName)
    )
    .sort((a, b) =>
      a.componentName.localeCompare(b.componentName)
    );

  let Benefitsdata =
    Array.isArray(Benefits) && Benefits.length > 0
      ? Benefits
          .filter((val) => typeof val?.componentName === "string")
          .sort((a, b) =>
            (a?.componentName || "").localeCompare(b?.componentName || "")
          )
      : [];

  const handleDownloadAndSave = async () => {
    const input = pdfRef.current;
    if (!input) return;

    try {
      setLoading(true);

      // Generate LOW-RES PDF for API upload
      const lowResCanvas = await html2canvas(input, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const lowResImgData = lowResCanvas.toDataURL(
        "image/jpeg",
        0.7
      );

      const lowResPdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const pageHeight = 297;

      const lowResImgHeight =
        (lowResCanvas.height * imgWidth) /
        lowResCanvas.width;

      let heightLeft = lowResImgHeight;
      let position = 0;

      lowResPdf.addImage(
        lowResImgData,
        "JPEG",
        0,
        position,
        imgWidth,
        lowResImgHeight,
        undefined,
        "FAST"
      );

      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - lowResImgHeight;

        lowResPdf.addPage();

        lowResPdf.addImage(
          lowResImgData,
          "JPEG",
          0,
          position,
          imgWidth,
          lowResImgHeight,
          undefined,
          "FAST"
        );

        heightLeft -= pageHeight;
      }

      const pdfBlob = lowResPdf.output("blob");

      // Save LOW-RES PDF to API
      await updateOfferLetter(
        offerId,
        pdfBlob
      );

      // Generate HIGH-QUALITY PDF for download
      const highResCanvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const highResImgData = highResCanvas.toDataURL(
        "image/png"
      );

      const highResPdf = new jsPDF("p", "mm", "a4");

      const highResImgHeight =
        (highResCanvas.height * imgWidth) /
        highResCanvas.width;

      let highResHeightLeft = highResImgHeight;
      let highResPosition = 0;

      highResPdf.addImage(
        highResImgData,
        "PNG",
        0,
        highResPosition,
        imgWidth,
        highResImgHeight
      );

      highResHeightLeft -= pageHeight;

      while (highResHeightLeft > 0) {
        highResPosition =
          highResHeightLeft - highResImgHeight;

        highResPdf.addPage();

        highResPdf.addImage(
          highResImgData,
          "PNG",
          0,
          highResPosition,
          imgWidth,
          highResImgHeight
        );

        highResHeightLeft -= pageHeight;
      }

      // Download HIGH-QUALITY PDF only after save
      highResPdf.save(
        `${
          candidatedetails?.candidateName
            ? candidatedetails.candidateName.replace(/\s+/g, "_")
            : "Employee"
        }_OfferLetter.pdf`
      );
    } catch (error) {
      console.error(
        "Error generating/uploading PDF:",
        error
      );

      Swal.fire({
        position: "center",
        icon: "error",
        title: "Failed to process PDF",
        text:
          error?.response?.data?.errors?.[0]?.message ||
          error?.message ||
          "Something went wrong",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      setLoading(false);
    }
  };

  const updateOfferLetter = async (id, pdfBlob) => {
    const uploadData = new FormData();

    uploadData.append(
      "operations",
      JSON.stringify({
        query: updateOfferLetterQuery,
        variables: {
          id,
          offer_letter_pdf: null,
        },
      })
    );

    uploadData.append(
      "map",
      JSON.stringify({
        0: ["variables.offer_letter_pdf"],
      })
    );

    uploadData.append(
      "0",
      pdfBlob,
      "OfferLetter.pdf"
    );

    const response = await axios.post(
      BASEURL,
      uploadData
    );

    const result = response.data?.data?.updateEmployeeOfferLetter;

    if (!result?.success) {
      throw new Error(
        result?.message || "Failed to save offer letter"
      );
    }

    return result;
  };

  const formattedDate = moment(
    Salarydata?.doj || Salarydata?.createdAt || new Date()
  ).format("DD MMMM YYYY");

  const Dateformat = moment(Salarydata?.createdAt || new Date()).format(
    "DD MMMM YYYY"
  );

  const NextDateformat = moment(Salarydata?.createdAt || new Date())
    .add(1, "days")
    .format("DD MMMM YYYY");

  const ctcAmount = Salarydata?.ctc || 0;
  const formattedCTC = formatNumberWithCommas(ctcAmount);
  const ctcInWords = numberToIndianWords(ctcAmount);

  const templateProps = {
    Salarydata,
    candidatedetails,
    EarningData,
    Deductiondata,
    Benefitsdata,
    formattedDate,
    Dateformat,
    NextDateformat,
    formattedCTC,
    ctcInWords,
  };

  return (
    <DashboardLayout>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            marginBottom: "15px",
          }}
        >
          <Button
            onClick={() => navigate('/offer-Letter')}
            variant="contained"
            startIcon={<ArrowBack />}
            sx={{
                backgroundColor: "#3f4277",
                color: "#fff",
                borderRadius: "5px",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "8px 16px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                "&:hover": {
                    backgroundColor: "#34365f",
                },
            }}
        >
            Back
        </Button>

        <Button
            onClick={handleDownloadAndSave}
            variant="contained"
            disabled={loading}
            startIcon={<Download />}
            sx={{
                padding: "10px 18px",
                backgroundColor: "#3f4277",
                color: "#fff",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                borderRadius: "5px",
                fontSize: "14px",
                fontWeight: "bold",
                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                transition: "background-color 0.3s ease",

                "&:hover": {
                    backgroundColor: "#34365f",
                },

                "&.Mui-disabled": {
                    backgroundColor: "#9a9cb8",
                    color: "#fff",
                },
            }}
        >
            {loading ? "Processing..." : "Download"}
        </Button>
        </div>

        {/* Parent container for PDF */}
        <div
          ref={pdfRef}
          style={{
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "210mm",
            padding: "0",
            margin: "0 auto",
          }}
        >
          {/* Render PDF Template according to assetsConfig company */}
          {assets.company === "Eg" ? (
            <EgOfferTemplate {...templateProps} />
          ) : (
            <KeelisOfferTemplate {...templateProps} />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default OfferPDF;